import { ReactNode, useMemo } from 'react';
import { cn, Dialog, DialogContent } from '@sib/ui';
import {
  withInteractOutsideGuard,
  withPointerDownOutsideGuard,
} from './DetailsModal.utils';

interface DetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  DialogContentProps?: React.ComponentPropsWithoutRef<typeof DialogContent>;
}

export const DetailsModal = ({
  isOpen,
  onClose,
  children,
  DialogContentProps,
}: DetailsModalProps) => {
  const {
    onPointerDownOutside,
    onInteractOutside,
    className,
    ...restDialogContentProps
  } = DialogContentProps ?? {};

  const handlePointerDownOutside = useMemo(
    () => withPointerDownOutsideGuard(onPointerDownOutside),
    [onPointerDownOutside]
  );

  const handleInteractOutside = useMemo(
    () => withInteractOutsideGuard(onInteractOutside),
    [onInteractOutside]
  );

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
      <DialogContent
        {...restDialogContentProps}
        onPointerDownOutside={handlePointerDownOutside}
        onInteractOutside={handleInteractOutside}
        className={cn(
          'flex h-[80vh] max-h-[90vh] w-full max-w-[90vw] flex-col items-stretch gap-2 overflow-hidden p-6 pb-10 sm:max-w-[70vw] sm:px-12 xl:max-w-[60vw]',
          className
        )}
      >
        {isOpen && children}
      </DialogContent>
    </Dialog>
  );
};
